var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 12C1.4375 6.20101 5.94264 1.5 11.5 1.5C17.0574 1.5 21.5625 6.20101 21.5625 12C21.5625 17.799 17.0574 22.5 11.5 22.5C5.94264 22.5 1.4375 17.799 1.4375 12Z",
    fill: "#172A73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00659 7.30859V7.7554L5.57198 8.01258C6.68117 8.1948 7.57512 9.06476 7.83355 10.2134L9.66603 18.3583C9.71138 18.5598 9.88255 18.7022 10.0796 18.7022H12.651C12.8207 18.7022 12.974 18.5961 13.0412 18.4324L17.477 7.62049C17.5375 7.47301 17.4347 7.30859 17.2819 7.30859H14.9127C14.7416 7.30859 14.5872 7.41646 14.5209 7.58228L11.5494 15.016L10.3641 8.40084C10.2506 7.7674 9.72433 7.30859 9.11127 7.30859H4.00659Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentVisa);
export default __webpack_public_path__ + "static/media/payment-visa.f90670446e4433dce7af808ddf0752f7.svg";
export { ForwardRef as ReactComponent };